import React from "react";
import styled, { css } from "styled-components/macro";
import { ReactComponent as CalendarSvg } from "./calendar.svg";
import { ReactComponent as CloseSvg } from "./close.svg";
import { ReactComponent as LeftArrowIcon } from "./leftArrow.svg";
import { ReactComponent as RightArrowIcon } from "./rightArrow.svg";
import { Button as ButtonOrig, LinkButton as LinkButtonOrig } from "../ui";
import FieldTemplate, { IFieldTemplate } from "../FieldTemplateWithError";

export const Button = styled(ButtonOrig)`
  font-size: 13px;
  line-height: 18px;
  height: 32px;
`;
export const LinkButton = styled(LinkButtonOrig)``;
export const LeftArrow = styled(LeftArrowIcon)``;
export const RightArrow = styled(RightArrowIcon)``;
export const CalendarWrap = styled.div`
  background: #ffffff;
  box-shadow: 0px 8px 18px rgba(57, 78, 127, 0.2);
  font: inherit;
  user-select: none;

  border: none !important;
  border-radius: 8px;

  .react-datepicker__header--custom {
    background: #ffffff;
    padding-top: 16px;
    border-bottom: 1px solid rgba(9, 21, 38, 0.15);
    border-radius: 0 !important;
  }
  .react-datepicker__day-name {
    width: 42px;
    height: 30px;
    line-height: 30px;
    font-size: 10px;
    color: rgba(9, 21, 38, 0.6);
    margin: 0;
    text-transform: capitalize;
  }
  .react-datepicker__month {
    margin: 0;
  }
  .react-datepicker__month-text {
    padding: 12px 0;
  }

  .react-datepicker__day {
    width: 42px;
    height: 41px;
    margin: 0;
    line-height: 41px;
    border-radius: 0;
    font-size: 14px;

    &--outside-month {
      background: rgba(9, 21, 38, 0.07);
    }
    &--disabled {
      color: rgba(9, 21, 38, 0.35);
    }
    &--in-range,
    &--in-selecting-range,
    &--keyboard-selected {
      background: #e0f5fb !important;
      color: rgba(9, 21, 38, 0.85) !important;
    }

    &:hover,
    &--selected,
    &--range-start,
    &--range-end,
    &--selecting-range-start,
    &--selecting-range-end,
    &--keyboard-selected {
      background: #00a8d9 !important;
      color: #fff !important;
      border-radius: 0;
    }
  }
`;
export const Calendar = styled.div`
  ${LeftArrow} {
  }
  ${RightArrow} {
  }
`;
export const CalendarHeader = styled.div`
  padding: 16px 16px 0 16px;
  display: flex;
  position: relative;
  &:after {
    content: "";
    top: 0;
    background: rgba(9, 21, 38, 0.15);
    left: 0;
    position: absolute;
    width: 100%;
    height: 1px;
  }
`;
export const CalendarHeaderDate = styled.div`
  font-size: 20px;
  line-height: 27px;
  flex: 1 0 auto;
  text-align: left;
`;
export const CalendarControls = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(9, 21, 38, 0.15);
`;
export const Wrap = styled.div`
  width: 176px;
`;
export const CalendarIcon = styled(CalendarSvg)`
  position: absolute;
  right: 5px;
`;

export const CloseIcon = styled(CloseSvg)`
  position: absolute;
  right: 5px;
`;

export const Content = styled.div`
  white-space: nowrap;
  overflow: hidden;
  margin-right: 21px;
`;

export const Placeholder = styled.span`
  color: rgba(9, 21, 38, 0.6);
`;

export const ContainerAbsolute = styled.div`
  position: absolute;
  top: 40px;
`;
type StyledFieldTemplateProps = React.PropsWithChildren<IFieldTemplate> & {
  empty: boolean;
};

export const StyledFieldTemplate = styled(
  FieldTemplate
)<StyledFieldTemplateProps>`
  padding: 7px 31px 7px 10px;
  ${CloseIcon} {
    display: none;
  }
  ${(props) =>
    !props.empty &&
    props.editabel &&
    !props.disable &&
    css`
      &:hover {
        ${CalendarIcon} {
          display: none;
        }
        ${CloseIcon} {
          display: block;
        }
      }
    `}

  ${(props) =>
    props.editabel
      ? css`
          svg path {
            fill: rgba(9, 21, 38, 0.85);
          }
        `
      : css`
          svg path {
            fill: rgba(9, 21, 38, 0.6);
          }
        `}
`;
